import React from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as IconHelpSVG } from '../../../assets/icons/icon-help.svg';
import Spinner from '../../UIComponents/Spinner';

const IconHelp = styled(IconHelpSVG)``;

const Component = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

const Header = styled.div`
  width: 100%;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HeaderTitle = styled.div`
  font-family: 'RobotoB', 'NotoKrB';
  font-size: 20px;
  color: ${(props) => props.theme.colors.grey800};
`;

const Split = styled.div`
  width: 100%;
  height: 1px;
  margin-top: 16px;
  margin-bottom: 24px;
  background-color: ${(props) => props.theme.colors.grey200};
`;

const Content = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const ContentItem = styled.div`
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0px;
  }
`;
const ContentItemTitle = styled.div`
  display: flex;
  align-items: center;
`;
const ContentItemTitleText = styled.div`
  font-family: 'RobotoM', 'NotoKrM';
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey800};
`;
const ContentItemTitleIcon = styled.div`
  width: 16px;
  height: 16px;
  margin-left: 8px;
  svg {
    width: 16px;
    height: 16px;
  }
`;

const ContentItemValue = styled.div`
  font-family: 'RobotoB', 'NotoKrB';
  font-size: 15px;
  color: ${(props) => props.theme.colors.grey800};
`;

const DataError = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  line-height: 1;
  color: ${(props) => props.theme.colors.grey800};
`;

interface PageUsabilityProps {
  pageUsabilityData: {
    effectiveClickRate: number | null;
    pageAttentionScreensCount: number | null;
    pageDuration: number | null;
  };
  loading: boolean;
}

const PageUsability = ({ pageUsabilityData, loading }: PageUsabilityProps) => {
  const printData = () => {
    if (loading) {
      return <Spinner />;
    }
    if (pageUsabilityData !== null) {
      return (
        <>
          <ContentItem>
            <ContentItemTitle>
              <ContentItemTitleText>유효 클릭 비율</ContentItemTitleText>
              {/* <ContentItemTitleIcon>
              <IconHelp />
            </ContentItemTitleIcon> */}
            </ContentItemTitle>
            <ContentItemValue>
              {Math.floor((pageUsabilityData.effectiveClickRate || 0) * 100) /
                100}
              %
            </ContentItemValue>
          </ContentItem>
          <ContentItem>
            <ContentItemTitle>
              <ContentItemTitleText>페이지 체류시간</ContentItemTitleText>
              {/* <ContentItemTitleIcon>
              <IconHelp />
            </ContentItemTitleIcon> */}
            </ContentItemTitle>
            <ContentItemValue>
              {Math.floor((pageUsabilityData.pageDuration || 0) * 100) / 100}초
            </ContentItemValue>
          </ContentItem>
          <ContentItem>
            <ContentItemTitle>
              <ContentItemTitleText>주목 화면 개수</ContentItemTitleText>
              {/* <ContentItemTitleIcon>
              <IconHelp />
            </ContentItemTitleIcon> */}
            </ContentItemTitle>
            <ContentItemValue>
              {pageUsabilityData.pageAttentionScreensCount || 0}개
            </ContentItemValue>
          </ContentItem>
        </>
      );
    }
    return <DataError>데이터를 불러오지 못했습니다.</DataError>;
  };

  return (
    <Component>
      <Header>
        <HeaderTitle>페이지 사용성</HeaderTitle>
      </Header>
      <Split />
      <Content>{printData()}</Content>
    </Component>
  );
};

export default PageUsability;
